/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
};

// getters
const getters = {
};

// mutations
const mutations = {
    
};

// actions
const actions = {
    // 公司列表显示
    CompanyListShow({ commit }, data) {
        return axios.post(http + '/org/company/show', data).then(res => {
            return res.data
        })
    },
    // 保存公司
    SaveCompany({ commit }, data) {
        return axios.post(http + '/org/company/add', data).then(res => {
            return res.data
        })
    },
    // 删除公司
    DelCompany({ commit }, data) {
        return axios.post(http + '/org/company/delete', data).then(res => {
            return res.data
        })
    }
    // 用户名登录
    // NoticeAdministrationListShow({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
        // return axios.post(http + '/notice/show', data).then(res => {
        //     return res.data
        // })
    // },
    // AddNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/add', data).then(res => {
    //         return res.data
    //     })
    // },
    // DeleteNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/delete', data).then(res => {
    //         return res.data
    //     })
    // }
};

const CompanyManagementModule = {
    state,
    getters,
    actions,
    mutations
}
export default CompanyManagementModule
